import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {CreditCardListComponent} from './credit-card-list/credit-card-list.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
    HTTP_INTERCEPTORS,
    HttpClientModule
} from '@angular/common/http';
import {NgbNavModule} from "@ng-bootstrap/ng-bootstrap";
import {CardDetailComponent} from './credit-card-list/card-detail/card-detail.component';
import {TermsConditionsComponent} from './credit-card-list/terms-conditions/terms-conditions.component';
import {SharedModule} from "./shared/shared.module";
import {HttpAuthInterceptor} from "./shared/services/http-auth.interceptor";
import { ErrorPageComponent } from './error-page/error-page.component';

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        CreditCardListComponent,
        CardDetailComponent,
        TermsConditionsComponent,
        ErrorPageComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        NgbNavModule,
        SharedModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpAuthInterceptor,
            multi: true
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
